export default "__VITE_ASSET__CiWzaOI5__"